module.exports = __webpack_public_path__ + "img/glasses_male_square_mask.e513200d.png";